import { createFeatureSelector, createSelector } from '@ngrx/store';

import { RemotePickupState } from './remote-pickup.reducer';

export const selectRemotePickupState = createFeatureSelector<RemotePickupState>('remotePickup');

export const selectRemotePickup = createSelector(selectRemotePickupState, (state) => state);

export const selectRemotePickupCode = createSelector(
  selectRemotePickupState,
  (state) => state.code
);

export const selectRemotePickupScheduleId = createSelector(
  selectRemotePickupState,
  (state) => state.schedule?.id ?? null
);

export const selectPosition = createSelector(
  selectRemotePickupState,
  (state) => state.state?.position ?? null
);
export const selectRemotePickupIndicator = createSelector(
  selectRemotePickupState,
  (state) => state.indicator
);

export const selectPickUpState = createSelector(
  selectRemotePickupState,
  (state) => state.state ?? null
);

export const selectPickUpStatus = createSelector(
  selectPickUpState,
  (state) => state?.status ?? null
);

export const selectIsOverflowArea = createSelector(
  selectRemotePickupState,
  (state) => state.isOverflowArea
);

export const selectShouldHandleDriverNotification = createSelector(
  selectRemotePickupState,
  (state) => state.shouldHandleDriverNotification
);

export const selectIsOffline = createSelector(selectRemotePickupState, (state) => state.isOffline);
